import React, { useState } from "react";
import logo from "./assets/images/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
// import "./Header.css";

const RathNavbar = () => {
  const navigate = useNavigate();


  const [submenu, setsubmenu] = useState({
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,

  });

  const toggleMenu = (e, menu) => {
    e.stopPropagation();
    setsubmenu((prevMenus) => ({
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      [menu]: !prevMenus[menu],
    }));
  };



  return (
    <>
      <div className="d-flex pb-2  header sticky top-0 z-50 justify-between items-center ">
        <NavLink to="/">
          <img
            loading="lazy"
            src={logo}
            alt="Iskcon Logo"
            className="iskcon-logo"
          />
        </NavLink>

        {/* <h1 className="md:text-4xl text-xl md:ml-0  absolute md:right-24 right-1  mt-2 font-garamond bg-gradient-to-br from-white via-yellow-400 via-orange-500 to-[#D2B48C] text-transparent bg-clip-text">
  ISKON  AMARAVATI  RATH  YATRA  2025
</h1> */}

 <div className="d-flex gap-2 align-items-center">
          <button
            onClick={() => {
              navigate("/QuickDonate");
              window.scrollTo(0, 0);
            }}
            className="btn donateBtn ml-auto"
          >
            QUICK DONATE
          </button>
          <button
            className="navbar-toggler bolck md:hidden"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
          </button>
        </div>

       
      </div>
    </>
  );
};

export default RathNavbar;
